import { DefaultFiltersType } from "../types";

export const defaultFilters: DefaultFiltersType = {
  aggregationsFilter: {},
  dateFilters: [{ startDate: "", endDate: "" }],
  dateType: "UPLOAD",
  filterPerYear: "",
  fullTextSearch: "",
  invoiceNumber: "",
  isFavourite: false,
  isUrgent: false,
  microCategory: [],
  onlyVisibleToMe: false,
  pageNumber: 0,
  pageSize: 20,
  readByAccountant: true,
  readByCompany: false,
  selectedChip: "Inbox",
  selectedMicro: "",
  sort: "date",
  sortOption: "LATEST_UPLOADS",
  tags: [],
  urgentDocs: false,
};
